export default "/images/7c870542a7f322ad8b8ee4631f0b39e7.avif";